import { Grid, styled } from "@material-ui/core"
import { Typography } from "@mui/material"

export const MenuCont = styled('div')(({ theme }) => ({
    position: 'absolute',
    bottom: '0px',
    left: '0px',
    width: '100%',
    height: '50%',
    backgroundColor: 'rgb(35, 35, 35)',
    zIndex: 2000,
    borderRadius: '20px 20px 0px 0px',
    padding: '15px',
    boxSizing: 'border-box'
}))

export const MenuSearchInput = styled('input')(({ theme }) => ({
    position: 'absolute',
    top: '15px',
    left: '50%',
    width: 'calc(100% - 25px)',
    height: '40px',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '10px',
    padding: '0px 10px',
    outline: 'none !important',
    border: '1px solid rgba(0, 0, 0, .5)',
    color: '#fff',
    transform: 'translate(-50%, 0%)',
    boxSizing: 'border-box'
}))

export const MenuItemsCont = styled(Grid)(({ theme }) => ({
    marginTop: '55px',
    maxHeight: 'calc(100% - 55px)',
    overflowY: 'auto'
}))

export const MenuItem = styled(Grid)(({ theme }) => ({
    minHeight: '150px',
    padding: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
}))

export const UserImg = styled('img')(({ theme }) => ({
    width: '80%',
    objectFit: 'cover',
    borderRadius: '50%',
    border: '3px solid #fff',
    cursor: 'pointer'
}))

export const Mention = styled('img')(({ theme }) => ({
    height: '100%',
    width: '100%',
    objectFit: 'contain',
    cursor: 'pointer',
    filter: 'invert(1)'
}))

export const MentionInput = styled('input')(({ theme }) => ({
    position: 'absolute',
    top: '30%',
    left: '50%',
    width: '200px',
    height: '50px',
    transform: 'translate(-50%, 0%)',
    color: 'yellow',
    backgroundColor: 'transparent',
    outline: 'none !important',
    border: 'none',
    fontSize: '1.8rem',
    zIndex: 2000
}))

export const NameText = styled(Typography)(({ theme }) => ({
    color: '#fff',
    fontSize: '1rem',
    textAlign: 'center'
}))

